import { _callBackend } from './api';
import type { Conversation } from '@/_types/models/conversations';
import type { APIRequest, APIResponsePromise } from '@/_types/api';

export const getMessages = async ({
  conversationId,
  token,
}: APIRequest<{
  conversationId: number;
}>): APIResponsePromise<Conversation> =>
  await _callBackend(`/v2/conversations/${conversationId}`, 'GET', null, token);

export const getCompanyConversation = async ({
  companyId,
  token,
}: APIRequest<{
  companyId: number;
}>): APIResponsePromise<Conversation> =>
  await _callBackend(
    `/conversations/get_client_conversation?company_id=${companyId}`,
    'GET',
    null,
    token,
  );

export const markConversationSeen = async ({
  conversationId,
  token,
}: APIRequest<{
  conversationId: number;
}>): APIResponsePromise =>
  await _callBackend(
    `/conversations/update_conversation_as_seen?conversation_id=${conversationId}`,
    'GET',
    null,
    token,
  );

export const markThreadSeen = async ({
  conversationId,
  threadId,
  token,
}: APIRequest<{
  conversationId: number;
  threadId: number;
}>): APIResponsePromise =>
  await _callBackend(
    `/conversations/update_thread_as_seen?conversation_id=${conversationId}&thread_id=${threadId}`,
    'GET',
    null,
    token,
  );

export const sendMessage = async ({
  conversationId,
  text,
  messageTag,
  hasReminder,
  messageThreadId,
  scheduledTime,
  token,
}: APIRequest<{
  conversationId: number;
  text: string;
  messageTag: string;
  hasReminder: boolean;
  messageThreadId?: number;
  scheduledTime?: string | null;
}>): APIResponsePromise =>
  await _callBackend(
    '/conversations/send_message',
    'POST',
    {
      conversation_id: conversationId,
      has_reminder: hasReminder,
      message_tag: messageTag,
      message_thread_id: messageThreadId,
      scheduled_time: scheduledTime,
      text,
    },
    token,
  );

export const getSmsStatus = async ({
  conversationId,
  token,
}: APIRequest<{
  conversationId: number;
}>): APIResponsePromise =>
  await _callBackend(
    `/conversations/sms_status?conversation_id=${conversationId}`,
    'GET',
    null,
    token,
  );
